import { useEffect } from 'react';

type ElementRef<T extends HTMLElement = HTMLElement> = {
  current: T | null;
};

type RatBinding = {
  $Selector(selector: HTMLElement): unknown;
  bind(selector: unknown): void;
};

// RAT binding implementation for click events
// https://confluence.rakuten-it.com/confluence/pages/viewpage.action?pageId=2617778545
const useRatBindClickComponent = <T extends HTMLElement>(
  node: ElementRef<T>,
  isEnabled: boolean = true,
) => {
  useEffect(() => {
    const rat = (window as typeof window & { RAT?: RatBinding }).RAT;

    if (isEnabled && node.current && rat) {
      rat.bind(rat.$Selector(node.current));
    }
  }, []);
};

export default useRatBindClickComponent;
